import { Typo3SectionSpotSanityContentText } from '@/types/typo3'
import { Button } from '@/ui/components'
import { memo } from 'react'

interface Props {
  links: Typo3SectionSpotSanityContentText['content']['links']
  files: Typo3SectionSpotSanityContentText['content']['files']
}

const Links = ({ links, files }: Props) => {
  if (!links?.length && !files?.length) {
    return null
  }
  return (
    <div
      className={
        'gap-sm p-md align-start grid grid-cols-1 justify-start border border-neutral-300'
      }
    >
      {links?.map((link, index) => (
        <Button
          key={index?.toString()}
          icon="material-symbols:chevron-right"
          size="s"
          variant="text"
          iconPosition="left"
          href={link?.link?.href}
          target={
            link?.link?.target === ''
              ? undefined
              : (link?.link?.target as string)
          }
          nextLink={link?.link?.target === '' ? true : false}
        >
          {link?.link?.title}
        </Button>
      ))}
      {files?.map((file, index) => (
        <Button
          key={index?.toString()}
          icon="material-symbols:download-sharp"
          size="s"
          variant="text"
          iconPosition="left"
          href={file?.publicUrl}
          target="_blank"
          nextLink={false}
        >
          {file.properties?.title}
        </Button>
      ))}
    </div>
  )
}
export default memo(Links)
